interface SeoMetadata {
  title: string;
  description: string;
  path: string;
  language: string;
  noIndex?: boolean;
}

const brand = 'Koinè';

function plainText(value: string): string {
  const documentValue = new DOMParser().parseFromString(value, 'text/html');
  return (documentValue.body.textContent ?? '').replace(/\s+/g, ' ').trim();
}

function setMeta(selector: string, attribute: string, key: string, value: string): void {
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.content = value;
}

function setLink(rel: string, href: string): void {
  let element = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement('link');
    element.rel = rel;
    document.head.appendChild(element);
  }
  element.href = href;
}

export function setSeoMetadata(metadata: SeoMetadata): void {
  const language = metadata.language.toLowerCase() === 'de' ? 'de' : 'it';
  const titleText = plainText(metadata.title) || brand;
  const description = plainText(metadata.description).slice(0, 160);
  const title = titleText.includes(brand) ? titleText : `${titleText} | ${brand}`;
  const canonicalUrl = new URL(metadata.path, window.location.origin).toString();
  const robots = metadata.noIndex ? 'noindex, nofollow' : 'index, follow';

  document.title = title;
  document.documentElement.lang = language;
  setMeta('meta[name="description"]', 'name', 'description', description);
  setMeta('meta[name="robots"]', 'name', 'robots', robots);
  setMeta('meta[property="og:type"]', 'property', 'og:type', 'website');
  setMeta('meta[property="og:site_name"]', 'property', 'og:site_name', brand);
  setMeta('meta[property="og:title"]', 'property', 'og:title', title);
  setMeta('meta[property="og:description"]', 'property', 'og:description', description);
  setMeta('meta[property="og:url"]', 'property', 'og:url', canonicalUrl);
  setMeta('meta[property="og:locale"]', 'property', 'og:locale', language === 'de' ? 'de_DE' : 'it_IT');
  setMeta('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary');
  setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', title);
  setMeta('meta[name="twitter:description"]', 'name', 'twitter:description', description);
  setLink('canonical', canonicalUrl);
}